import React from "react";
import { Table, Button } from "reactstrap";
import { MINIJUEGOS, HISTORIAS, PLANETAS, NIVELES, CINTURONES } from "./consts_act";
import {
  countOrInteractiveButtonBasedOnFunction,
  countOrInteractiveHeaderBasedOnFunction
} from "../../../../../utils/helperMethods";

export default class TablaProvincia extends React.Component {
  render() {
    if (!this.props.data) return null;
    console.warn(this.props);
    return (
      <Table hover className="mb-0">
        <thead>
          <tr>
            <th className="text-center">Provincias</th>
            {countOrInteractiveHeaderBasedOnFunction(this.props.openLocalidades,"Localidades")}
            {countOrInteractiveHeaderBasedOnFunction(this.props.openInstituciones,"Instituciones")}
            {countOrInteractiveHeaderBasedOnFunction(this.props.openDocentes,"Docentes")}
            {countOrInteractiveHeaderBasedOnFunction(this.props.openEstudiantes,"Usuarios")}
  
          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>
              
                <td className="text-center">{e.nombre}</td>

                {countOrInteractiveButtonBasedOnFunction(this.props.openLocalidades,e,"Localidades",e.countLocalidades)}
                {countOrInteractiveButtonBasedOnFunction(this.props.openInstituciones,e,"Instituciones",e.instituciones)}
                {countOrInteractiveButtonBasedOnFunction(this.props.openDocentes,e,"Docentes",e.docentes)}
                {countOrInteractiveButtonBasedOnFunction(this.props.openEstudiantes,e,"Estudiantes",e.alumnos)}
               
              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Provincia/component/ProvinciaList.js